import { APP_ENV, getEnvValue, IS_PROD_ENV } from './envConfig';

export const GOOGLE_CLIENT_ID = getEnvValue('REACT_APP_GOOGLE_CLIENT_ID');


export const GOOGLE_OAUTH_ENV = IS_PROD_ENV ? 'prod' : 'dev';

export const GOOGLE_OAUTH_APP_ENV = APP_ENV;
